import { getAudio } from "@/audio";

const SCALE = [261.63, 293.66, 329.63, 392, 440, 523.25, 587.33, 659.25];
const CHORDS = [[130.81, 196, 329.63], [110, 164.81, 261.63], [87.31, 130.81, 220], [98, 146.83, 246.94]];
const LENGTH = 120;
let playing = null;

const tone = (ctx, dest, f, at, dur, peak, type = "sine") => {
  const o = ctx.createOscillator();
  const g = ctx.createGain();
  o.type = type;
  o.frequency.value = f;
  g.gain.setValueAtTime(0, at);
  g.gain.linearRampToValueAtTime(peak, at + dur * 0.4);
  g.gain.linearRampToValueAtTime(0, at + dur);
  o.connect(g).connect(dest);
  o.start(at);
  o.stop(at + dur + 0.05);
};

let busNode = null;

export const stopLullaby = () => {
  if (!playing) return;
  clearTimeout(playing);
  const { ctx } = getAudio();
  busNode.gain.cancelScheduledValues(ctx.currentTime);
  busNode.gain.setTargetAtTime(0, ctx.currentTime, 0.4);
  const b = busNode;
  setTimeout(() => b.disconnect(), 2500);
  playing = null;
  busNode = null;
  window.__lullabyOn = false;
  window.__lullabyMode = null;
};

export const startLullaby = ({ seconds = LENGTH, direct = false } = {}) => {
  if (playing && !direct) return;
  stopLullaby();
  const { ctx, out } = getAudio();
  const len = Math.max(4, seconds);
  const now = ctx.currentTime;
  const bus = ctx.createGain();
  const lp = ctx.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.value = 1800;
  bus.gain.setValueAtTime(0, now);
  bus.gain.linearRampToValueAtTime(0.05, now + Math.min(6, len / 4));
  if (direct) bus.gain.linearRampToValueAtTime(0, now + len);
  else {
    bus.gain.setValueAtTime(0.05, now + len - 8);
    bus.gain.linearRampToValueAtTime(0, now + len);
  }
  bus.connect(lp).connect(direct ? ctx.destination : out);
  busNode = bus;
  const beat = 0.75;
  const t0 = now + 0.1;
  const steps = Math.floor(len / beat);
  let note = 4;
  for (let i = 0; i < steps; i++) {
    const at = t0 + i * beat;
    if (i % 8 === 0) CHORDS[(i / 8) % CHORDS.length].forEach((f) => tone(ctx, bus, f, at, beat * 8, 0.25, "triangle"));
    if (Math.random() < 0.7) {
      note = Math.max(0, Math.min(SCALE.length - 1, note + Math.floor(Math.random() * 5) - 2));
      tone(ctx, bus, SCALE[note], at, 2.2, 0.22, "triangle");
    }
  }
  playing = setTimeout(() => { bus.disconnect(); playing = null; busNode = null; window.__lullabyOn = false; window.__lullabyMode = null; }, len * 1000 + 500);
  window.__lullabyOn = true;
  window.__lullabyMode = direct ? "sleep" : "crash";
  window.__lullabies = (window.__lullabies || 0) + 1;
};
